import { render, staticRenderFns } from "./ActiveSales.vue?vue&type=template&id=2e4d518f&scoped=true&"
import script from "./ActiveSales.vue?vue&type=script&lang=js&"
export * from "./ActiveSales.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSales.vue?vue&type=style&index=0&id=2e4d518f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4d518f",
  null
  
)

export default component.exports